import styled from "styled-components";

export const ContentPaymentMethod = styled.div`
  display: flex;
  flex: 1;
  min-width: 700px;
`;
